const initCountdowns = () => {
  document.querySelectorAll('[data-countdown-root]').forEach((root) => {
    const target = root.dataset.countdownDate;
    const timer = root.querySelector('[data-countdown-timer]');
    if (!target || !timer) return;
    const updateTimer = () => {
      const diff = new Date(target).getTime() - Date.now();
      if (diff <= 0) {
        timer.innerHTML = '<span>Live now</span>';
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      timer.innerHTML = `<span>${String(days).padStart(2, '0')}d</span><span>${String(hours).padStart(2, '0')}h</span><span>${String(minutes).padStart(2, '0')}m</span>`;
    };
    updateTimer();
    window.setInterval(updateTimer, 60000);
  });
};
document.addEventListener('DOMContentLoaded', () => { initCountdowns(); });
